import { useState } from 'react';
import { Button } from '../input';
import { Modal, closeHook } from '../modal';
import { styles } from '../../constants';
import { useGlobal } from '../../state';
import { TableFromObject } from '../table';
import { Run } from '../run';

export const Args = ({ job }) => {
  const close = closeHook();

  console.log('close hook', close);

  return (
    <div style={{ ...styles.uiBox, display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={{ maxWidth: 800 }}>
        <TableFromObject obj={job.args} />
      </div>
      <div>
        <Modal title={`Run ${job.name}`} close={close.signal}>
          <Button>Run Again</Button>
          <Run endpoint={job.name} params={job.args} onRun={close.trigger} />
        </Modal>
      </div>
    </div>
  );
};
